<template>
  <v-flex xs12 class="mb-4">
    <v-card>
      <v-card-title>
        <div class="flex-container-space-between">
          <layout-no-padding>
            <page-title :routeProps="routeProps"></page-title>
          </layout-no-padding>

          <div class="vertical-center-container text-xs-right">
            <v-btn
              :color="$store.state.global.pages.tip.color"
              flat
              router
              :icon="!$vuetify.breakpoint.smAndUp"
              :to="{name: 'tip'}"
            >
              <v-icon :left="$vuetify.breakpoint.smAndUp">{{$store.state.global.pages.tip.icon}}</v-icon>
              {{$vuetify.breakpoint.smAndUp ? 'See Tips...' : ''}}
            </v-btn>
            <v-tooltip left v-if="userAuthClass">
              <v-btn
                slot="activator"
                icon
                large
                flat
                :color="$store.state.global.pages[$route.name].color"
                @click="importDialog = true"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>Import Tipping Dockets
            </v-tooltip>
            <v-btn icon flat color="grey" class="mr-0" @click="drawer = !drawer">
              <v-icon>playlist_add</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm6 lg3>
            <v-autocomplete
              label="Choose filter"
              :items="filterCols"
              v-model="filterCol"
              prepend-icon="list"
              :clearable="true"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 sm6 md3>
            <v-text-field
              label="Filter by..."
              v-model="filterBy"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 sm6 md3>
            <v-autocomplete
              label="Status"
              :items="statusItems"
              v-model="filterStatus"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-autocomplete>
            <!-- hint="<div class='indigo--text'>Overrides 'Show Closed Option'</div>"
            persistent-hint-->
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 sm6 lg3 class="pt-0">
            <div class="flex-container-space-between">
              <v-autocomplete
                label="Choose filter"
                :items="filterCols"
                v-model="filterCol2"
                prepend-icon="list"
                :clearable="true"
              ></v-autocomplete>
            </div>
          </v-flex>
          <v-flex xs12 sm6 md3 class="pt-0">
            <v-text-field
              label="Filter by..."
              v-model="filterBy2"
              prepend-icon="filter_list"
              :clearable="true"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="mx-3 mb-5">
        <div class="flex-container-space-between">
          <div></div>
          <div>
            <chip-display></chip-display>
          </div>
        </div>
        <card-divider-full></card-divider-full>
      </div>
      <v-card-actions></v-card-actions>
      <v-btn
        fab
        dark
        :color="$store.state.global.pages[$route.name].color"
        class="overlap-fab"
        @click="importDialog = !importDialog"
        v-if="$store.state.user.userAuthClass.tippingEntry"
      >
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-card>

    <filter-drawer></filter-drawer>

    <v-dialog v-model="importDialog" lazy max-width="700px" v-if="userAuthClass">
      <import-tipping-dockets @close="importDialog = false" title="Import Tipping Dockets"></import-tipping-dockets>
    </v-dialog>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import RouteProps from '@/services/mixins/routeProps'

import { addDays } from 'date-fns'
import FormatDates from '@/services/mixins/formatDates'
import DateRangeOptions from '@/services/mixins/dateRangeOptions'
import StatusItems from '../mixins/statusItems'
import FilterDrawer from '@/components/trips/filterDrawer'
import ChipDisplay from '@/components/ui/chipDisplay'

import ImportTippingDockets from '@/components/trips/actions/importDockets'
export default {
  mixins: [RouteProps, FormatDates, DateRangeOptions, StatusItems],
  data() {
    return {
      addBatchDialog: false,
      importDialog: false,
      filterCols: [
        {
          value: 'tippingDocketLine.id',
          text: 'ID'
        },
        {
          value: 'tippingDocketHeader.externalRef',
          text: 'Reference'
        },
        {
          value: 'tippingDocketHeader.date',
          text: 'Date'
        },
        {
          value: 'status',
          text: 'Status'
        },
        {
          value: 'tippingDocketHeader.project.name',
          text: 'Project'
        },
        {
          value: 'wbDocketNumber',
          text: 'W/B Docket #'
        },
        {
          value: 'spoil.name',
          text: 'Spoil'
        },
        {
          value: 'tippingDocketHeader.tip.name',
          text: 'Tip'
        },
        {
          value: 'tippingDocketHeader.vehicle.contractor.name',
          text: 'Sub-Contractor'
        },
        {
          value: 'tippingDocketHeader.vehicle.name',
          text: 'Vehicle'
        },
        {
          value: 'tippingDocketHeader.vehicle.vehicleType.name',
          text: 'Vehicle Type'
        },
        {
          value: 'tippingDocketHeader.vehicle.vin',
          text: 'VIN'
        },
        {
          value: 'qty',
          text: 'Qty'
        },
        {
          value: 'costPrice',
          text: 'Cost Price'
        },
        {
          value: 'costTotal',
          text: 'Cost Total'
        },
        {
          value: 'isDay',
          text: 'Day / Night'
        },
        {
          value: 'tippingDocketLine.notes',
          text: 'Notes'
        },
        {
          value: 'tippingDocketLine.createdAt',
          text: 'Created At'
        },
        {
          value: 'tippingDocketLine.updatedAt',
          text: 'Updated At'
        },
        {
          value: 'createdBy.name',
          text: 'Created By'
        },
        {
          value: 'updatedBy.name',
          text: 'Updated By'
        }
      ]
    }
  },
  components: {
    FilterDrawer,
    ChipDisplay,
    ImportTippingDockets
  },
  computed: {
    filterCol: Store.getSet({ store: 'tipping', prop: 'filterCol' }),
    filterBy: Store.getSet({ store: 'tipping', prop: 'filterBy' }),
    filterCol2: Store.getSet({ store: 'tipping', prop: 'filterCol2' }),
    filterBy2: Store.getSet({ store: 'tipping', prop: 'filterBy2' }),
    filterStatus: Store.getSet({ store: 'tipping', prop: 'filterStatus' }),
    drawer: Store.getSet({ store: 'shared', prop: 'drawer' })
  }
}
</script>

<style>
.overlap-fab {
  position: absolute !important;
  bottom: -33px;
  right: 20px;
}
</style>